const ONBOARDING_URL_KEY = 'cl-onboarding-redirect-url';

export const storeOnboardingUrl = (url: string): void => {
    try {
        localStorage.setItem(ONBOARDING_URL_KEY, url);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn('Failed to store onboarding URL in localStorage:', error);
    }
};

export const getStoredOnboardingUrl = (): string | null => {
    try {
        return localStorage.getItem(ONBOARDING_URL_KEY);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn('Failed to retrieve onboarding URL from localStorage:', error);
        return null;
    }
};

export const clearStoredOnboardingUrl = (): void => {
    try {
        localStorage.removeItem(ONBOARDING_URL_KEY);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn('Failed to clear onboarding URL from localStorage:', error);
    }
};
